import type { TimelineSection } from "@/modules/corporate/types/sections"
import type { FunctionComponent } from "react"

import { Layout } from "@jobteaser/ui-kit/components/Layout/Layout"
import { Paper, PAPER_RADIUS } from "@jobteaser/ui-kit/components/Paper/Paper"
import { Text, TEXT_TYPES, TEXT_WEIGHTS } from "@jobteaser/ui-kit/components/Text/Text"
import { Tag } from "@jobteaser/ui-kit/deprecated/Tag/Tag"

import { Title } from "@/modules/corporate/components/Sections/Title/Title"
import { getDate } from "@/modules/dates/dates"
import { RichText } from "@/modules/kontent/components/RichText"

import styles from "./Timeline.module.css"

export type TimelinePropsType = {
  section: TimelineSection
}

export const Timeline: FunctionComponent<TimelinePropsType> = ({ section }) => (
  <Layout className={styles.main} hasTopPadding hasBottomPadding>
    <Layout.Column>
      {!!section.title && <Title title={section.title} tag="h2" isCentered />}
      {!!section.events.length && (
        <ul className={styles.list}>
          {section.events.map(event => (
            <li className={styles.item} key={event.title}>
              <Paper className={styles.card} radius={PAPER_RADIUS.DEFAULT} smallSpacing hasBorder noShadow>
                <Tag>
                  {getDate({
                    date: new Date(`${event.date}`),
                    dateFormat: {
                      year: "numeric",
                    },
                    timeZone: "Europe/Paris",
                  })}
                </Tag>
                <Text
                  className={styles.cardTitle}
                  type={TEXT_TYPES.HEADING_SMALL}
                  weight={TEXT_WEIGHTS.EXTRA_BOLD}
                  tag="h2"
                  resetSpacing
                >
                  {event.title}
                </Text>

                <RichText
                  value={event.description}
                  wrapperProps={{
                    className: styles.cardText,
                    resetSpacing: true,
                    tag: "div",
                  }}
                />
              </Paper>
            </li>
          ))}
        </ul>
      )}
    </Layout.Column>
  </Layout>
)
